var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15513 0.805927C5.35507 0.615467 5.6716 0.623167 5.86207 0.823113C6.05253 1.02307 6.0448 1.33955 5.84487 1.53001L1.67727 5.49973H11.5C11.7761 5.49973 12 5.7236 12 5.99973C12 6.27587 11.7761 6.49973 11.5 6.49973H1.6772L5.84487 10.4695C6.0448 10.66 6.05253 10.9765 5.86207 11.1765C5.6716 11.3764 5.35507 11.3841 5.15513 11.1937L0.2092 6.48253C0.0966005 6.37527 0.0299339 6.2384 0.00926685 6.0962C0.00320053 6.065 0 6.03273 0 5.99973C0 5.96673 0.00319958 5.9344 0.00933266 5.90313C0.0299997 5.761 0.0966673 5.62427 0.2092 5.51707L5.15513 0.805927Z",
    fill: "#161616"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRightArrow);
export default __webpack_public_path__ + "static/media/whiteRightArrow.03e84f43fe6ac68213a6442547e31f98.svg";
export { ForwardRef as ReactComponent };